import { keyframes, styled } from '@mui/system';

// Define the keyframes
const infiniteRotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Styled = {};

// Create a styled wrapper component
Styled.LoadingWrapper = styled('div')({
  '& svg': {
    animation: `${infiniteRotate} 1s linear infinite`,
  },
});

export default Styled;